import CCPProgram from "../assets/CCPProgram.jpg";

export default function CommunityCareProgram() {
  return (
    <div className="bg-gray-50">  

      {/* ✅ Content Section */}
      <section className="py-12 max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-start">
        {/* ✅ Text Column */}
        <div className="space-y-4 text-gray-700 leading-relaxed">
          <p>
            We collaborate with several local Managed Care Organizations
            including Illinois Department on Aging, Illinois Department of Human
            Services, Humana, Aetna, Blue Cross Blue Shield, Illinicare and
            County Care for our Community Care Program. Seniors who qualify can
            receive free home care services. To be eligible, applicants must:
          </p>

          <ul className="list-none space-y-2">
            {[
              "Be 60 years or older",
              "Be a U.S. citizen or legal alien",
              "Be a resident of Illinois",
              "Have non-exempt asset value of less than $17,500",
              "Have an assessed need for care",
              "Have applied for Medicaid",
            ].map((item, index) => (
              <li key={index} className="flex items-start">
                <span className="text-green-600 text-lg mr-2">✔</span> {item}
              </li>
            ))}
          </ul>

          <p>
            After submitting an application, Care Coordination Units from
            counties will evaluate eligibility. Once approved, a plan of care
            will be drafted and hours assigned.
          </p>

          <p>
            Family members can also serve as caregivers — providing comfort and
            familiarity to seniors in need.
          </p>
        </div>

        {/* ✅ Image Column */}
        <div>
          <img
            src={CCPProgram}
            alt="Community-Care-Program"
            className="w-full rounded-lg shadow-md"
          />
        </div>
      </section>
    </div>
  );
}
